/**
 * Utility functions for rendering runtime diagnostics and writing to a popout window.
 */

export const getRuntimeBundleName = () => {
  if (typeof document === 'undefined') return '';
  const bundleSrc = document.querySelector('script[src*="/static/js/main."]')?.getAttribute('src');
  return bundleSrc ? bundleSrc.split('/').pop() : '';
};

export const escapeDiagnosticsHtml = value =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

export const writeDiagnosticsWindow = (targetWindow, rows) => {
  if (!targetWindow || targetWindow.closed) return;
  const renderedRows = rows
    .map(
      ([label, value]) => `
        <div class="row">
          <dt>${escapeDiagnosticsHtml(label)}</dt>
          <dd>${escapeDiagnosticsHtml(value || 'n/a')}</dd>
        </div>`
    )
    .join('');

  targetWindow.document.open();
  targetWindow.document.write(`<!doctype html>
    <html>
      <head>
        <title>USDN diagnostics</title>
        <style>
          body {
            margin: 0;
            background: #08090a;
            color: #f4efe7;
            font: 12px ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
          }
          header {
            position: sticky;
            top: 0;
            padding: 14px 16px;
            background: #08090a;
            border-bottom: 1px solid rgba(212, 181, 114, 0.28);
            color: #d4b572;
            font-weight: 800;
            letter-spacing: 0.08em;
            text-transform: uppercase;
          }
          dl {
            display: grid;
            grid-template-columns: minmax(130px, 0.42fr) minmax(0, 1fr);
            gap: 7px 12px;
            margin: 0;
            padding: 16px;
          }
          .row {
            display: contents;
          }
          dt {
            color: #8f8a82;
          }
          dd {
            min-width: 0;
            margin: 0;
            overflow-wrap: anywhere;
          }
        </style>
      </head>
      <body>
        <header>Diagnostics</header>
        <dl>${renderedRows}</dl>
      </body>
    </html>`);
  targetWindow.document.close();
};
